"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const HeaderPart_1 = require("./HeaderPart");
const OfferedServices_1 = require("./OfferedServices");
const ContactUsPart_1 = require("../../components/ContactUsPart");
const FooterPart_1 = require("../../components/FooterPart");
const PartnersPart_1 = require("../../components/PartnersPart");
const DocumentTitle = require("react-document-title");
class LandingAbout extends React.Component {
    componentDidMount() {
        document.body.scrollTop = 0;
        $('#aboutItem').addClass('active-item');
    }
    componentWillUnmount() {
        $('#aboutItem').removeClass('active-item');
    }
    render() {
        return React.createElement(DocumentTitle, { title: "LoyalReach - Everything about LoyalReach and big team behind it" }, React.createElement(react_bootstrap_1.Grid, { fluid: true }, React.createElement(HeaderPart_1.default, null), React.createElement(OfferedServices_1.default, null), React.createElement(PartnersPart_1.default, null), React.createElement(ContactUsPart_1.default, null), React.createElement(FooterPart_1.default, null)));
    }
}
exports.default = LandingAbout;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/whyUs/components/WhyUs.tsx
// module id = 1094
// module chunks = 0 1